<div class="wrapper-feedback">
    <div class="section-title row">
        <div class="section-btn">
            <button class="btn btn-back" [attr.aria-label]="'Back' | translate">
              <i class="fi-rr-arrow-alt-left"></i>
            </button>
        </div>
        <div>
            <h1 class="title">Feedback Topic</h1>
        </div>
    </div>

    <!--<div class="section-action">
        <div>
            <img class="all-icon" src="../../../assets/icon/all.svg" alt="icon">
            <div ngbDropdown class="d-inline-block w-100">
                <button class="btn btn-outline-primary text-indent-40" id="dropdownBasic1" ngbDropdownToggle>All</button>
                <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="custom-dropdown">
                    <button ngbDropdownItem>Dropdown 1</button>
                    <button ngbDropdownItem>Dropdown Active</button>
                    <button ngbDropdownItem>Dropdown 2</button>
                    <button ngbDropdownItem>Dropdown 2</button>
                </div>
            </div>
        </div>
        <div class="form-group">
            <div ngbDropdown class="d-inline-block w-100">
                <button class="btn btn-outline-primary" id="dropdownBasic1" ngbDropdownToggle>Product/Transaction/ID</button>
                <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="custom-dropdown">
                    <button ngbDropdownItem>Dropdown 1</button>
                    <button ngbDropdownItem>Dropdown Active</button>
                    <button ngbDropdownItem>Dropdown 2</button>
                    <button ngbDropdownItem>Dropdown 2</button>
                </div>
            </div>
        </div>
    </div>-->

    <div class="section-main">
        <div class="table-history table-responsive mx-auto">
            <table class="table">
                <thead>
                    <tr>
                        <th class="border-left-0 text-start w-150" scope="col">
                            Topic
                        </th>
                        <th class="border-right-0 text-center" scope="col">
                            status
                        </th>
                        <th class="border-right-0 text-center" scope="col">
                            action
                        </th>
                    </tr>
                </thead>
                <tbody *ngFor="let data of feedback">
                    <tr>
                        <td class="border-left-0 text-start">{{data.topic}}</td>
                        <td class="border-right-0 text-center">
                            {{data.status}}
                        </td>
                        <td class="border-right-0 text-center">
                          <a class="link" (click)="goFeedbackListPage(data.feedback_topic_id)" routerLinkActive="link-active" >Edit</a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
